import * as THREE from 'three';
import { FeaturePreviewLineMaterialFactory } from '../../material';

/**
 * 特征预览描边对象。
 *
 * 文件定位：
 * 1. 当前文件位于 cad-core 的 mesh/feature 目录，属于三维特征可视化对象层；
 * 2. 它只服务于预览体描边显示，不承担正式实体的交互、选择或拓扑语义；
 * 3. 通过覆写 raycast 禁用拾取，确保预览描边不会进入选择链。
 */
export class FeaturePreviewLine extends THREE.LineSegments {
  /**
   * 构造函数。
   *
   * @param geometry 预览描边几何。
   */
  public constructor(geometry: THREE.BufferGeometry) {
    super(geometry, FeaturePreviewLineMaterialFactory.getMaterial());
    this.name = '特征预览描边';
    this.renderOrder = 12;
  }

  /**
   * 禁用预览描边拾取。
   *
   * 设计说明：
   * 1. 用户已明确要求预览描边仅作显示，不应响应事件；
   * 2. 因此这里直接覆写 raycast，彻底阻断选择管理器命中到预览边线。
   */
  public override raycast(): void {
    return;
  }
}
